import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICamp } from '../model/camp.model';
import { ITamRefPays } from '../model/tam-ref-pays.models';
import { IProjetAnnee } from '../model/projet-annee.model';
import { ISortParams } from '../model/sort-params.model';

@Component({
    selector: 'ddc-projects-information-card',
    templateUrl: './ddc-projects-information-card.component.html',
    styleUrls: ['./ddc-projects-information-card.component.scss'],
    standalone: false
})
export class DdcProjectsInformationCardComponent {

  @Input() set titleLabelKey(titleLabelKey: string) {
    this._titleLabelKey = titleLabelKey;
  }

  @Input() set projetsAnnee(projetsAnnee: IProjetAnnee[]) {
    this._projetsAnnee = projetsAnnee;
  }

  @Input() set camps(camps: ICamp[]) {
    this._camps = camps;
  }

  @Input() set displayedColumns(displayedColumns: string[]) {
    this._displayedColumns = displayedColumns;
  }

  @Input() set listePays(listePays: ITamRefPays[]) {
    this._listePays = listePays;
  }

  @Input() set nbreTotalItems(nbreTotalItems: number) {
    this._nbreTotalItems = nbreTotalItems;
  }

  @Input() set itemsPerPage(itemsPerPage: number) {
    this._itemsPerPage = itemsPerPage;
  }

  @Output() pageChanged = new EventEmitter();

  @Output() sortResults = new EventEmitter();

  _titleLabelKey: string;
  _camps: ICamp[];
  _displayedColumns: string[];
  _listePays: ITamRefPays[];
  _projetsAnnee: IProjetAnnee[];
  _nbreTotalItems: number;
  _itemsPerPage: number;

  constructor() {

  }

  onChangePage(pageNumber: number) {
    this.pageChanged.emit(pageNumber);
  }

  updateSortParams(sortParams: ISortParams) {
    this.sortResults.emit(sortParams);
  }
}
